import { useRef } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { useGetLmsLookupTranslationsQuery } from '../../../api';

const LmsCodeMultiSelect = ({
    groupCode,
    value,
    onChange,
    placeholder,
    disabled = false,
    className = '',
    invalid = false,
    id
}) => {
    const multiSelectRef = useRef(null);

    const { data, isLoading } = useGetLmsLookupTranslationsQuery({
        groupCode,
        isActive: 1,
        pageNumber: 1,
        pageSize: 100
    });

    const options = (data?.items ?? []).map((item) => ({
        code: item.code,
        text: item.text
    }));

    return (
        <MultiSelect
            ref={multiSelectRef}
            id={id}
            value={value ?? []}
            options={options}
            optionLabel="text"
            optionValue="code"
            onChange={(event) => {
                onChange(event.value);
                multiSelectRef.current?.hide();
            }}
            placeholder={placeholder}
            loading={isLoading}
            disabled={disabled}
            filter
            showClear
            display="chip"
            className={`${className} ${invalid ? 'p-invalid' : ''}`.trim()}
        />
    );
};

export default LmsCodeMultiSelect;